module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAA2UlEQVRoQ+2ZwQ3CQAwE14WQflIJNVEJ/SSFHC8+CKRz7LUSs7zjNZ6xThcwNPlYkzmgQc5mUkZkhERAq0UCezj2q5ExxgrgAeB2OJlTuAO4m9nzM/7XINsJh3h/993Mlr8bpMdqcdabm6rjl8vXny4jfmbcChnh8vWny4ifGbeitxHdfrnbo9vv9V+sajYkt0vvUyuXVU2ajNRwnu8iI/Osap6UkRrO8116G9Htd34TIk/qt98Ivexa398K2d0r8nqfWhUEs3vISDbRaJ6MRAlm18tINtFo3gu0+UIzS9XQEAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/nav-phone/nav_home_m.png
// module id = 50hE
// module chunks = 4